// One definition of the names Sheets navigates and groups by, so a route or a
// Sheet type is never spelled out again in a component.
export const SHEET_ROUTES = {
  PARENT: "sheets",
  LIST: "sheets-list",
  DETAIL: "sheets-detail",
};

// The list route marks the Sheet it opens by itself. Reading the marker off the
// navigation is what separates the app's own choice from a Sheet the reader
// asked for; where the reader came from does not say which it was.
export const OPENED_BY_DEFAULT_PARAM = "opened_by_default";

// The profile the list route chose that Sheet for. Carried with the marker so
// a redirect that settles after the profile moved on is answered before any
// request goes out, rather than waiting for the new list to arrive.
export const OPENED_FOR_PROFILE_PARAM = "opened_for_profile";

export const SHEET_TYPES = {
  ALL_CONTACTS: "all_contacts",
  AUTO_FILL: "auto_fill",
  MANUAL: "manual",
};

// vue-router reports a navigation that a newer one replaced as an error, and
// flags all of them with `_isRouter`. Only the repeated one carries a name, so
// the flag is the reliable test.
export function isNavigationOutcome(error) {
  return Boolean(error?._isRouter);
}
